var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.stakeholderIds,"multiple":true,"items":_setup.stakeholderItems,"outlined":"","dense":""},on:{"input":(val) => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }